import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TabRouterLessNavigationItem } from '@app/navigation/navigation.model';
import { TranslateService } from '@ngx-translate/core';
import { LDFlagsService } from '@app/shared/services/ld-flags.service';
import { AddResourcesModel } from './services/add-resources-modal.service';
import { AddModalResults } from '@app/pathways/pathway-api.model';

@Component({
  selector: 'dgx-add-resources-modal',
  templateUrl: './add-resources-modal.component.html',
})
export class AddResourcesModal implements OnInit {
  public i18n = this.translate.instant(['Core_Search', 'Pathways_AddByType']);
  public isSubmitting = false;
  public searchItems: LearningResourceViewModel[] = [];
  public tabList: TabRouterLessNavigationItem[];

  @Input() public addResourcesModel: AddResourcesModel;

  @ViewChild('addBySearch', { static: true })
  public addBySearchRef: TemplateRef<any>;
  @ViewChild('addByType', { static: true })
  public addByTypeRef: TemplateRef<any>;

  constructor(
    private activeModal: NgbActiveModal,
    private ldFlagsService: LDFlagsService,
    private translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.searchItems = this.addResourcesModel.savedSearch;

    this.setupTabs();
  }

  public itemsAdded = (results: AddModalResults) => {
    this.isSubmitting = true;
    this.addResourcesModel.onAddItems(results, this.activeModal.close);
  };

  public updateSearchItems = (results) => {
    this.searchItems = results.savedItems;
  };

  public dismiss = () => {
    this.activeModal.dismiss({
      selectedSearch: this.searchItems,
    });
  };

  private setupTabs() {
    this.tabList = [
      {
        name: this.i18n.Core_Search,
        nameId: 'addBySearch',
        template: this.addBySearchRef,
      },
    ];

    if (!this.addResourcesModel.hideFeatures) {
      this.tabList.push({
        name: this.i18n.Pathways_AddByType,
        nameId: 'addByType',
        template: this.addByTypeRef,
      });
    }
  }
}
